import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ActivitySessionWaitingContactsTable from '@activities/components/tables/activity-session-waiting-contacts-table/activity-session-waiting-contacts-table.vue';

@Component({
  name: 'bpc-activity-session-attendees',
  components: {
    'bpc-activity-session-waiting-contacts-table': ActivitySessionWaitingContactsTable,
  },
})
export default class ActivitySession extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
